import { request, setCsrfToken } from './client';
import { AuthMeResponse, OptionsResponse } from '../types/auth';

export async function fetchAuthMe(): Promise<AuthMeResponse> {
  const data = await request<AuthMeResponse>('/auth/me');
  if (data.csrf_token) {
    setCsrfToken(data.csrf_token);
  }
  return data;
}

export async function fetchRegisterOptions(name?: string): Promise<OptionsResponse> {
  const payload: Record<string, string> = {};
  if (name && name.trim()) {
    payload.name = name.trim();
  }
  return request<OptionsResponse>('/auth/register/options', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function verifyRegistration(challenge_id: string, credential: any): Promise<any> {
  const result = await request<any>('/auth/register/verify', {
    method: 'POST',
    body: JSON.stringify({ challenge_id, credential }),
  });
  // Refresh me to ensure CSRF token and auth status are updated
  await fetchAuthMe();
  return result;
}

export async function fetchLoginOptions(): Promise<OptionsResponse> {
  return request<OptionsResponse>('/auth/login/options', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export async function verifyLogin(challenge_id: string, credential: any): Promise<any> {
  const result = await request<any>('/auth/login/verify', {
    method: 'POST',
    body: JSON.stringify({ challenge_id, credential }),
  });
  // Refresh me
  await fetchAuthMe();
  return result;
}

export async function logoutUser(): Promise<void> {
  await request<void>('/auth/logout', {
    method: 'POST',
    body: JSON.stringify({}),
  });
  setCsrfToken(null);
}
